<template>
    <div class="ml-4 flex flex-col">
        <div class="hidden md:block flex items-center grid grid-cols-2">
            <span>Items Per Page</span>
            <select2    v-model:value="numPerPage"
                        :options="options"
                        :close-on-select="true"></select2>
        </div>
        <div    v-if="showPageInfo"
                class="text-gray-500">
            Showing {{ currentLow }} to {{ currentHigh }} of {{ totalResults }} Results
        </div>
    </div>
</template>

<script>
import Select2 from "@/components/elements/select2";

export default {
    name: "ItemsPerPageSelect",
    mixins: [],
    components: {Select2},
    props: {
        itemsPerPage: {
            type: String,
            default: '25'
        },
        currentLow: {
            type: Number,
            default: null,
        },
        currentHigh: {
            type: Number,
            default: null,
        },
        totalResults: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            options: {
                10: '10',
                25: '25',
                50: '50',
                75: '75',
                100: '100',
            },
            numPerPage: this.itemsPerPage,
        }
    },
    mounted() {

    },
    methods: {

    },
    watch: {
        numPerPage() {
            this.$emit('update:itemsPerPage', this.numPerPage)
        },
        itemsPerPage() {
            this.numPerPage = this.itemsPerPage
        }
    },
    computed: {
        showPageInfo() {
            return this.currentLow && this.currentHigh && this.totalResults
        }
    },
}
</script>

<style scoped>

</style>